import { Link } from "react-router-dom";

const comparisonCards = [
  {
    title: "Hipobuy vs Kakobuy",
    description: "Compare product coverage, research efficiency, and safety features between Hipobuy Spreadsheet and Kakobuy Spreadsheet.",
    to: "/hipobuy-spreadsheet-vs-kakobuy",
    icon: "ri-scales-3-line",
    image: "https://readdy.ai/api/search-image?query=Split%20composition%20contrasting%20warm%20terracotta%20organized%20product%20research%20scene%20with%20cool%20navy%20minimalist%20workspace%2C%20soft%20natural%20lighting%20bridging%20both%20sides%2C%20clean%20editorial%20comparison%20concept%20with%20product%20catalogs%20and%20tablets%20on%20matching%20desks%2C%20harmonious%20visual%20contrast%20between%20two%20distinct%20aesthetic%20approaches%20to%20shopping%20research&width=400&height=280&seq=comp-kakobuy-card&orientation=landscape"
  },
  {
    title: "Hipobuy vs CSSBuy",
    description: "Detailed head-to-head analysis of data organization, user experience, and educational resources for smarter shopping.",
    to: "/hipobuy-spreadsheet-vs-cssbuy",
    icon: "ri-scales-3-line",
    image: "https://readdy.ai/api/search-image?query=Side%20by%20side%20workspace%20comparison%20with%20warm%20amber%20organized%20desk%20featuring%20structured%20product%20research%20materials%20on%20left%2C%20minimalist%20sage%20green%20workspace%20with%20streamlined%20setup%20on%20right%2C%20diffused%20window%20light%20connecting%20both%20environments%2C%20sophisticated%20editorial%20photography%20capturing%20the%20contrast%20between%20comprehensive%20and%20simplified%20research%20approaches&width=400&height=280&seq=comp-cssbuy-card&orientation=landscape"
  },
  {
    title: "Hipobuy vs Superbuy",
    description: "Quality versus quantity analysis. See how curated data compares to volume-based product aggregation.",
    to: "/hipobuy-spreadsheet-vs-superbuy",
    icon: "ri-scales-3-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20comparison%20scene%20with%20organized%20curated%20product%20catalog%20workspace%20in%20warm%20terracotta%20and%20cream%20tones%20on%20one%20side%2C%20contrasting%20with%20larger%20more%20scattered%20product%20research%20station%20in%20neutral%20gray%20and%20white%20on%20the%20other%2C%20soft%20morning%20light%20illuminating%20both%20setups%2C%20editorial%20catalog%20photography%20capturing%20the%20quality%20versus%20quantity%20research%20philosophy&width=400&height=280&seq=comp-superbuy-card&orientation=landscape"
  },
  {
    title: "Hipobuy vs Oopbuy",
    description: "Established platform versus fresh newcomer. Compare maturity, features, and visual design philosophy.",
    to: "/hipobuy-spreadsheet-vs-oopbuy",
    icon: "ri-scales-3-line",
    image: "https://readdy.ai/api/search-image?query=Dual%20desk%20setup%20comparison%20with%20established%20comprehensive%20product%20research%20station%20in%20warm%20amber%20tones%20featuring%20detailed%20spreadsheets%20and%20catalogs%20on%20left%2C%20modern%20sleek%20minimalist%20workspace%20with%20fresh%20clean%20design%20aesthetic%20in%20olive%20beige%20tones%20on%20right%2C%20gentle%20natural%20lighting%2C%20sophisticated%20editorial%20product%20photography%20style&width=400&height=280&seq=comp-oopbuy-card&orientation=landscape"
  },
  {
    title: "Category Deep-Dive",
    description: "Master all 14 product categories. Learn category-specific research strategies for shoes, jackets, bags, perfumes and more.",
    to: "/hipobuy-spreadsheet-category-deep-dive",
    icon: "ri-stack-line",
    image: "https://readdy.ai/api/search-image?query=Beautifully%20organized%20flat%20lay%20of%20diverse%20product%20categories%20arranged%20in%20neat%20color%20coordinated%20rows%20on%20warm%20cream%20linen%20surface%2C%20shoes%20hoodies%20accessories%20bags%20belts%20and%20perfume%20bottles%20styled%20with%20elegant%20simplicity%2C%20soft%20diffused%20natural%20daylight%2C%20sophisticated%20retail%20catalog%20photography%2C%20warm%20terracotta%20and%20amber%20accent%20tones%20creating%20cohesive%20visual%20harmony&width=400&height=280&seq=comp-catdeep-card&orientation=landscape"
  },
  {
    title: "Complete Guide",
    description: "Read our comprehensive 2000+ word guide covering everything from getting started to advanced research techniques.",
    to: "/hipobuy-spreadsheet-complete-guide",
    icon: "ri-book-open-line",
    image: "https://readdy.ai/api/search-image?query=Cozy%20reading%20corner%20with%20open%20guidebook%20on%20wooden%20desk%20beside%20laptop%20showing%20research%20dashboard%2C%20warm%20golden%20hour%20light%20through%20window%2C%20reading%20glasses%20and%20ceramic%20mug%2C%20soft%20knitted%20throw%20on%20chair%20in%20background%2C%20intellectual%20lifestyle%20photography%20with%20cream%20amber%20and%20terracotta%20color%20palette%2C%20sophisticated%20learning%20environment%20aesthetic&width=400&height=280&seq=comp-complete-card&orientation=landscape"
  },
];

export default function ComparisonHub() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Comparison Hub
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
            Spreadsheet Platform Comparisons &amp; Guides
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore our in-depth comparison pages and category research guides to find the best spreadsheet tools for your shopping needs.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {comparisonCards.map((card) => (
            <Link
              key={card.to}
              to={card.to}
              className="group block rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  title={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-background-50/90 flex items-center justify-center">
                    <i className={`${card.icon} text-sm text-primary-600`}></i>
                  </div>
                  <span className="text-sm font-semibold text-white">{card.title}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {card.description}
                </p>
                <div className="flex items-center gap-1 mt-3 text-primary-600 text-xs font-medium group-hover:gap-2 transition-all">
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}